import * as Constants from '../Constants'
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchPersonDetails = createAsyncThunk("fetchPersonDetails", async (rbr) => {

  var myHeaders = new Headers();
  myHeaders.append("X-Api-Key", "ApiKeyTest");
  myHeaders.append('Access-Control-Allow-Origin', Constants.PATH);
  myHeaders.append('Access-Control-Allow-Credentials', 'true');
  myHeaders.append('Content-Type', 'application/json');
  var requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow',
    dataType: "json"
  };
  const queryParams = new URLSearchParams({
    rbr: rbr,
    oznakaMesta: Constants.UNIVERSE,

  }).toString();

  const fullUrl = `${Constants.API_ROOT}/api/Lupa/GetLupa?${queryParams}`;


try {
  const res = await fetch(fullUrl, requestOptions);

  if (!res.ok) {
    throw new Error(`HTTP error! Status: ${res.status}`);
  }

  const data = await res.json();
  return data;
} catch (err) {
  console.error("Fetch failed:", err);
  return null;
}
});

